import { Navigate } from 'react-router-dom';
import Login from '../pages/Login.js';
import { isTokenValid } from '../utils/auth.js';

const getToken = () => localStorage.getItem('auth_token');

const AppEntry = () => {
  if (isTokenValid(getToken())) return <Navigate to="/home" replace />;
  return <Login />;
};

export default AppEntry;
